import MuiMenuItem, { MenuItemProps as MuiMenuItemProps } from '@mui/material/MenuItem';

const MenuItem = (props: MuiMenuItemProps): JSX.Element => {
  return <MuiMenuItem {...props} />;
};

export default MenuItem;
